import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import store from "./app/store";
import { BrowserRouter } from 'react-router-dom';
import AppWrapper from './wrappers/AppWrapper';

// Suppress Chrome dev ResizeObserver loop noise so CRA overlay does not mask the UI
if (typeof window !== "undefined") {
  const ignoreResizeObserverError = (event) => {
    if (event?.message && event.message.includes("ResizeObserver loop")) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  };

  window.addEventListener("error", ignoreResizeObserverError);
  window.addEventListener("unhandledrejection", (event) => {
    const message = event?.reason?.message || "";
    if (message.includes("ResizeObserver loop")) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <AppWrapper>
      <App />
      </AppWrapper>
    </Provider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
